var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBrandFont32Filled = function SvgIconBrandFont32Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.913 17.007h3.166c.07 0 .141-.002.21-.007h.177c.621 0 1.127.506 1.127 1.127v.127c0 .62-.506 1.126-1.127 1.126h-3.553v-2.373ZM17.205 15a1.129 1.129 0 0 0 1.001-1.12v-.126c0-.621-.506-1.127-1.127-1.127h-3.166V15h3.292Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.733 6.2A3.533 3.533 0 0 0 6.2 9.734v12.533A3.533 3.533 0 0 0 9.733 25.8h12.533a3.533 3.533 0 0 0 3.534-3.533V9.734A3.533 3.533 0 0 0 22.266 6.2H9.733Zm3.18 4.427a1 1 0 0 0-1 1v8.753a1 1 0 0 0 1 1h4.553a3.128 3.128 0 0 0 3.127-3.126v-.127a3.12 3.12 0 0 0-1.043-2.33c.41-.53.656-1.195.656-1.916v-.127a3.128 3.128 0 0 0-3.127-3.127h-4.166Z",
    fill: "current"
  })));
};
export default SvgIconBrandFont32Filled;